import { Fragment } from "react";
import {Carousel} from "react-bootstrap";
import { Shop } from "react-bootstrap-icons";

import API from "Constants/Apis";

import "./style.css";

const HeroImage = ({ subject, medias }) => {
  return (
    <Fragment>
      <section className="all-hero-image">
        <div className="hero-image container p-0 ">
          {
            medias?.length > 1 ?
                <div className="slider-box p-0 ">
                  <Carousel
                      variant="dark"
                      fade="true"
                      nextIcon={null}
                      prevIcon={null}
                      interval="2500"
                  >
                    {medias.map((item, i) => {
                      return (
                          <Carousel.Item key={i}>
                            <img className="w-100" src={`${API.BASE_URL_IMAGE}${item.media_path}`}/>
                          </Carousel.Item>
                      );
                    })}
                  </Carousel>
                </div>
                :
                <>
                  {
                      medias?.length &&
                      <img className="w-100 img-single-blog" src={`${API.BASE_URL_IMAGE}${medias[0].media_path}`}/>
                  }
                </>

          }
          <div
              className="title-business-category d-flex justify-content-between align-items-center       border-bottom p-4 ">
            <h6 className="m-0 link-roud-map">{subject}</h6>

            <div className="icon-part d-flex justify-content-between align-items-center">
              <Shop className="ms-1 border-start ps-2" size={25} />
              <p className="m-0 link-roud-map">وبلاگ</p>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default HeroImage;
